import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Card, CardContent } from '../../components/ui/card';
import CalendarHeader from '../../components/calendar/calendar-header';
import CalendarWeekView from '../../components/calendar/calendar-week-view';
import CalendarDayView from '../../components/calendar/calendar-day-view';
import AppointmentModal from '../../components/calendar/reservation-calendar-details';
import NewAppointmentModal from '../../components/calendar/reservation-calendar-modal';
import EditManualBookingModal from '../../components/calendar/edit-manual-booking-modal';
import CollaboratorSelect from '../../components/dashboard/collaborator-select';
import { calendarStore } from '../../store/calendar-store';
import companyStore from '../../store/company-store';
import professionalStore from '../../store/professional-store';
import { useCalendarViewModel} from '../../view-model/professional/calendar-view-model';
import OnboardingTour from '../onboarding/onboarding-tour';
import { SECTION_CALENDAR } from '../../constants/onboarding-sections';
import ReviewTutorialButton from '../../components/onboarding/review-tutorial-button';

const Calendar: React.FC = observer(() => {
  const calendarViewModel = useCalendarViewModel();

  // Charger la compagnie sélectionnée pour le select des collaborateurs et initialiser le collaborateur connecté
  useEffect(() => {
    const companyId = companyStore.getIdCompanySelectedDefault;
    const currentUserId = professionalStore.getId;

    if (!companyId || !currentUserId) {
      return;
    }

    companyStore.setCompanyById(companyId);

    // Sélectionner le collaborateur connecté par défaut
    if (companyStore.selectedCompany?.collaboratorCompanies) {
      const currentCollaborator = companyStore.selectedCompany.collaboratorCompanies.find(
        c => c.collaboratorId === currentUserId
      );
      if (currentCollaborator) {
        calendarViewModel.setSelectedCollaboratorId(currentCollaborator.collaboratorCompagnieId);
      }
    }
  }, [companyStore.selectedCompany, professionalStore.getId, calendarViewModel]);

  const handleCollaboratorChange = (collaboratorId: string) => {
    calendarViewModel.setSelectedCollaboratorId(collaboratorId);
  };

  return (
    <>
    <OnboardingTour section={SECTION_CALENDAR} />
    <div className="pb-4">

      {/* Collaborator Select */}
      <div className="mt-3 w-full md:w-80">
        <CollaboratorSelect
          value={calendarViewModel.selectedCollaboratorId}
          onChange={handleCollaboratorChange}
        />
      </div>

      <div className="fixed bottom-6 z-50">
        <ReviewTutorialButton section={SECTION_CALENDAR}/>
      </div>

      <div className="mt-6 h-[calc(100vh-6rem)]">
        <Card className="flex-1 flex flex-col h-full overflow-hidden">
          {/* En-tête du calendrier */}
          <CalendarHeader />

          {/* Contenu du calendrier */}
          <CardContent className="flex-1 p-0 overflow-auto h-[calc(100vh-12rem)]">
            {/* Vue semaine uniquement sur desktop */}
            <div className="hidden md:block">
              {calendarViewModel.getCurrentView === 'week' ? (
                <CalendarWeekView />
              ) : (
                <CalendarDayView />
              )}
            </div>
            {/* Vue jour forcée sur mobile */}
            <div className="md:hidden">
              <CalendarDayView />
            </div>
          </CardContent>
        </Card>
      </div>
      
      {/* Modal de détails du rendez-vous */}
      {calendarViewModel.getShowEventDetails && calendarStore.selectedBooking && (
        <AppointmentModal />
      )}

      {/* Modal de création de rendez-vous */}
      <NewAppointmentModal />

      {/* Modal d'édition de réservation manuelle */}
      <EditManualBookingModal />
    </div>
    </>
  );
});

export default Calendar;
